module.exports = __webpack_public_path__ + "static/media/BeaconMedispendLoginLogo.f4d0a92f.svg";